<template>
  <div class="exchange-code-manage">
    <div class="header">
      <div class="back" @click="$router.go(-1)">
        <a-icon type="left" /><span>返回</span>
      </div>
      <div class="card-name">{{ cardName }}兑换码管理</div>
      <div class="close" @click="$router.go(-1)"><a-icon type="close" /></div>
    </div>
    <div class="filter">
      <div class="filter-status">
        <div>
          <span style="margin-right: 20px">状态筛选</span>
          <template v-for="tag in tags">
            <a-checkable-tag
              :key="tag"
              :checked="selectedTags.indexOf(tag) > -1"
              @change="(checked) => handleChange(tag, checked)"
            >
              {{ tag }}
            </a-checkable-tag>
          </template>
        </div>
        <div>
          <a-button type="primary" icon="plus" @click="visible = true"
            >生成兑换码</a-button
          >
        </div>
      </div>
      <div>
        <a-input-search
          allowClear
          v-model="params.keyword"
          placeholder="关键词搜索"
          style="width: 300px"
          @search="getExchnageCodeList"
          @pressEnter="getExchnageCodeList"
        />
      </div>
    </div>
    <a-table
      class="exchange-code-table"
      :columns="columns"
      :data-source="dataSource"
      :row-key="(record) => record.id"
      :pagination="pagination"
      @change="tableChange"
    >
      <!-- 授权码 -->
      <div slot="code" slot-scope="text">
        <div class="exchangeCode">
          <span @click="mixin_copy(text)">{{ text }}</span>
          <a-icon type="copy" class="copy" @click="mixin_copy(text)" />
        </div>
      </div>
      <!-- 状态 -->
      <template slot="state" slot-scope="text">
        <a-tag :color="text == 1 ? 'blue' : 'green'">
          {{ text == 1 ? '已兑换' : '未兑换' }}
        </a-tag>
      </template>
      <template slot="operation" slot-scope="text, record">
        <span
          @click="handleDelete(record)"
          style="color: #ff0000; cursor: pointer"
          ><a-icon type="delete" /> 删除</span
        >
      </template>
    </a-table>
    <generateCodeModal
      v-if="visible"
      :visible.sync="visible"
      @refresh="getExchnageCodeList"
    />
  </div>
</template>

<script>
import copyMixin from '@/utils/mixin/copy.js'
import generateCodeModal from './modal/generateCodeModal.vue'
const columns = [
  {
    title: '兑换码',
    dataIndex: 'code',
    key: 'code',
    scopedSlots: { customRender: 'code' },
  },
  {
    title: '时长',
    dataIndex: 'day',
    key: 'day',
    customRender: (text) => {
      return text + '天'
    },
  },
  {
    title: '状态',
    dataIndex: 'state',
    key: 'state',
    align: 'center',
    scopedSlots: { customRender: 'state' },
  },
  {
    title: '兑换用户手机号码',
    dataIndex: 'phone',
    key: 'phone',
    customRender: (text) => {
      return text ? text : '--'
    },
  },
  {
    title: '兑换开始时间',
    dataIndex: 'startTime',
    key: 'startTime',
    customRender: (text) => {
      return text ? text : '--'
    },
  },
  {
    title: '会员失效结束时间',
    dataIndex: 'endTime',
    key: 'endTime',
    customRender: (text) => {
      return text ? text : '--'
    },
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
  },
  {
    title: '操作',
    key: 'operation',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
]
export default {
  name: 'exchangeCodeManage',
  mixins: [copyMixin],
  components: {
    generateCodeModal,
  },
  data() {
    return {
      columns,
      tags: ['全部', '已兑换', '未兑换'],
      selectedTags: ['全部'],
      cardName: '会员卡',
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true,
        onChange: (page, pageSize) =>
          this.handlePaginationChange(page, pageSize),
        onShowSizeChange: (page, pageSize) =>
          this.handlePaginationChange(page, pageSize),
      },
      dataSource: [],
      visible: false,
      params: {
        page: 1,
        size: 10,
        state: null,
        keyword: null,
        vipCardId: this.$route.query.id,
      },
    }
  },
  created() {
    this.getExchnageCodeList()
  },
  methods: {
    getExchnageCodeList() {
      this.dataSource = []
      this.params.page = this.pagination.current
      this.params.size = this.pagination.pageSize
      if (!this.params.keyword) this.params.keyword = null

      this.$api.getExchangeCodeList(this.params).then((res) => {
        this.dataSource = res.content
        this.pagination.total = Number(res.totalElements)
      })
    },
    handleChange(tag, checked) {
      if (checked) {
        this.selectedTags = [tag]
        this.params.state = tag === '全部' ? '' : tag === '已兑换' ? '1' : '0'
      } else {
        this.selectedTags = ['全部']
      }
      this.getExchnageCodeList()
    },
    tableChange(pagination) {
      let { current, pageSize } = pagination
      this.pagination.current = current
      this.pagination.pageSize = pageSize
    },
    handleDelete(record) {
      console.log(record)
      this.$confirm({
        title: '确定删除吗？',
        content: <span style="color: red">删除后不可恢复，请谨慎操作</span>,
        onOk: () => {
          this.$api
            .delExchangeCode(record.id)
            .then((res) => {
              this.$message.success('删除成功')
              this.getExchnageCodeList()
            })
            .catch((err) => {
              this.$message.error('删除失败')
            })
        },
      })
    },
    handlePaginationChange(current, pageSize) {
      Object.assign(this.pagination, { current, pageSize })
      this.getExchnageCodeList()
    },
  },
}
</script>

<style lang="less" scoped>
.exchange-code-manage {
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid #e8e8e8;
    .back {
      display: flex;
      align-items: center;
      margin-right: 20px;
      span {
        margin-left: 5px;
      }
      &:hover {
        color: #0059ff;
        cursor: pointer;
      }
    }
    .card-name {
      font-size: 14px;
      font-weight: bold;
    }
    .close {
      font-size: 14px;
      &:hover {
        color: #8f8f9f;
        cursor: pointer;
      }
    }
  }
  .filter {
    margin: 16px 20px;
    .filter-status {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }
  }
  .exchange-code-table {
    margin: 0 20px;
    .exchangeCode {
      color: #0059ff;
      cursor: pointer;
      font-size: 15px;
      font-weight: 400;
      .copy {
        color: #bbbcbf;
        margin-left: 3px;
        &:hover {
          color: #0059ff;
        }
      }
    }
  }
}
</style>